module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._v("\n    个人中心\n")])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-23e5ec91"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/page/User.vue
// module id = 596
// module chunks = 2